module.exports = __webpack_public_path__ + "static/media/Login.34804c5f.png";